import MatchingVacanciesAddBanner from './MatchingVacanciesAddBanner.component';

export default MatchingVacanciesAddBanner;